import { DIAL_CODES } from "../billing/dialCodes";
import { PHONE_LEN } from "../billing/phoneLengths";

// Strict, country-driven validation for national ID / passport numbers.
export const idError = (rule, kind, value) => {
  const v = (value || "").trim();
  if (!v) return null;
  if (!rule) return "selectCountry";
  const min = kind === "id" ? rule.id_min : rule.pp_min;
  const max = kind === "id" ? rule.id_max : rule.pp_max;
  if (kind === "id" && rule.id_digits && !/^\d+$/.test(v)) return "digits";
  if (!/^[A-Za-z0-9-]+$/.test(v)) return "chars";
  if (v.length < min || v.length > max) return "length";
  return null;
};

// أكواد الاتصال مرتّبة من الأطول للأقصر لمطابقة البادئة الأدق (مثل +1246 قبل +1).
const DIALS = Object.entries(DIAL_CODES)
  .map(([code, dial]) => ({ code, d: dial.replace("+", "") }))
  .sort((a, b) => b.d.length - a.d.length);

// يفصل قيمة هاتف الطوارئ المخزّنة («+كود الدولة + الرقم») إلى دولة ورقم محلي.
export const parseEmergency = (value) => {
  const raw = (value || "").replace(/[^\d]/g, "");
  if (!raw) return { code: "", local: "" };
  for (const { code, d } of DIALS) {
    if (raw.startsWith(d) && raw.slice(d.length).length === (PHONE_LEN[code] || 9)) {
      return { code, local: raw.slice(d.length) };
    }
  }
  for (const { code, d } of DIALS) if (raw.startsWith(d)) return { code, local: raw.slice(d.length) };
  return { code: "", local: raw };
};

export const emergencyPhoneError = (value) => {
  const v = (value || "").trim();
  if (!v) return null;
  const { code, local } = parseEmergency(v);
  if (!code) return "country";
  return local.length === (PHONE_LEN[code] || 9) ? null : "length";
};

export const personalErrors = (personal, rule) => ({
  national_id: idError(rule, "id", personal.national_id),
  passport_number: idError(rule, "pp", personal.passport_number),
  emergency_phone: emergencyPhoneError(personal.emergency_phone),
});

export const hasErrors = (errors) => Object.values(errors).some(Boolean);
